<template>
    <div class="body">
        <div class="bg"></div>
        <!-- <div class="popup" v-if="flag"></div> -->
        <div class="content">
            <div class="back" @click="$router.go(-1)">
                <img src="../../assets/img/i19.png" />
                返回
            </div>
            <div class="top">
                <div class="top_left">
                    <el-image class="t_left" :src="webImg + ktInfo.qrCode" :preview-src-list="[webImg + ktInfo.qrCode]"
                        v-if="ktInfo && ktInfo.qrCode"></el-image>
                    <div class="t_right">
                        <div class="tr_top">
                            <div class="trt_left">{{ ktInfo.courseName }}</div>
                            <div class="trt_right" @click="btn_analysis">
                                <img src="../../assets/img/i25.png" />
                                班级分析
                                <img src="../../assets/img/i26.png" />
                            </div>
                        </div>
                        <div class="tr_bottom">班级：{{ ktInfo.className }} <div></div> 学科：{{ ktInfo.subjectName }}</div>
                    </div>
                </div>
                <div class="top_right">
                    <!-- , query: { id: this.ktId }  -->
                    <!-- <div class="tr_btn2" @click="btn_open(1)">
                        <img src="../../assets/img/i31.png" />
                        课堂转录
                    </div>
                    <div class="tr_btn2" @click="btn_open(2)">
                        <img src="../../assets/img/i31.png" />
                        讲座会议转录
                    </div> -->
                    <div class="tr_btn1" @click="finishClassPop = true" v-if="ktInfo.status == 0">
                        <!-- <img src="../../assets/img/i21.png" /> -->
                        结束上课
                    </div>
                    <div class="tr_btn" @click="btn_start" v-if="ktInfo.status == 2">
                        <!-- <img src="../../assets/img/i20.png" /> -->
                        开始上课
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="c_left">
                    <div class="cl_label" :class="tabIndex == index ? 'cll1' : ''" v-for="(item, index) in tabList"
                        :key="index" :title="item.helperName" @click="btn_tab(index)">
                        <img :src="webImg + item.icon" />
                        <div class="cll_tit line1_" :class="tabIndex == index ? 'cll' : ''">{{ item.helperName }}</div>
                        <div class="cll_line" v-if="tabIndex == index"></div>
                        <!-- <img class="switch" title="结束使用" src="../../assets/img/i39.png" @click="startAndEnd(1,index)" v-if="item.status == 0"/> -->
                        <!-- <img class="switch" title="开始使用" src="../../assets/img/i38.png" @click="startAndEnd(0,index)"  v-if="item.status != 0" /> -->
                    </div>
                </div>
                <div class="c_right" style="margin-right: 20px;" @click="flag3 = true"
                    v-if="zntStatus == 1 && tabList[tabIndex].type == 4 && helperEvaluateStatus == 0">
                    选择智能体
                </div>
                <div class="c_right" @click="btn_openCt"
                    v-if="zntStatus == 1 && tabList[tabIndex].type == 4 && helperEvaluateStatus == 0">
                    <img src="../../assets/img/i20.png" />
                    开始出题
                </div>
                <div class="c_right1" @click="startAndEnd(1)" v-if="zntStatus == 0 && tabList[tabIndex].type == 4">
                    <img src="../../assets/img/i21.png" />
                    结束使用
                </div>
                <!-- 状态 0-使用中 1-结束使用 2-上课前 -->
                <div class="c_right1" @click="startAndEnd(1)" v-if="zntStatus == 0 && tabList[tabIndex].type != 4">
                    <img src="../../assets/img/i21.png" />
                    结束使用
                </div>
                <div class="c_right" @click="startAndEnd(0)"
                    v-if="zntStatus == 1 && (ktInfo.status == 0 || ktInfo.status == 2) && tabList[tabIndex].type != 4 && helperEvaluateStatus == 0">
                    <img src="../../assets/img/i20.png" />
                    开始使用
                </div>
            </div>
            <div class="bottom">
                <div class="b_left">
                    <div class="bl_item" :title="`${item.studentName} (No:${item.studentNo} )`"
                        v-for="(item, index) in stuList" :key="index" @click="btn_stu(item, index)">
                        <img class="border" src="../../assets/img/i64.png" v-if="item.score && item.score > 3"/>
                        <div class="bli_label" :class="item.id ? '' : 'blil'">{{ item.evaluateStatus &&
                            item.evaluateStatus > 0 ? (item.evaluateStatus == 1 ? '分析中' : item.evaluateStatus == 2 ?
                                '分析成功' : '分析失败') : item.id ? '使用中' : '未使用' }}</div>
                        <img :class="item.score && item.score > 3 ? 'b1' :''" :src="webImg + item.avatar" />
                        <div class="line1_">{{ item.studentName }} (No:{{ item.studentNo }} )</div>
                    </div>
                </div>

                <div class="b_right">
                    <div class="br_tit ">
                        <div class="brt_left">数据看板</div>
                        <div class="brt_right line1_" v-if="tabList[tabIndex]">({{
                            tabList[tabIndex].helperName }})</div>
                    </div>
                    <div class="br_box" id="oneChart" v-if="chartInfo && chartInfo.indicator.length > 0"></div>
                    <el-empty description="暂无数据" v-else></el-empty>

                    <div class="br_bottom">
                        <div class="brb_top">课堂分析结果</div>
                        <div class="brb_bottom" v-html="markedt(preprocessLaTeX(zntEve || ''))" v-if="zntEve"></div>
                        <el-empty description="暂无数据" v-else></el-empty>
                    </div>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
            <div class="chat">
                <div class="ch_top">
                    <img class="close" src="../../assets/img/i18.png" @click="flag = false, stuId = ''" />
                    <div class="cht_left">个体对话详情</div>
                    <div class="cht_right">
                        <div class="htr_stu">
                            <!-- <img :src="webImg + stuItem.avatar" /> -->
                            {{ stuItem.studentName }}
                        </div>
                        与
                        <div class="htr_znt">
                            <!-- <img :src="webImg + tabList[tabIndex].icon" /> -->
                            {{ tabList[tabIndex].helperName }}
                        </div>
                        的对话
                    </div>
                </div>
                <div class="ch_bottom" ref="scrollDiv">
                    <div class="chb_item" v-for="(item, index) in chatList" :key="index"
                        v-if="(index != 1 && tabList[tabIndex].type == 4) || tabList[tabIndex].type != 4">
                        <div class="chb_left" v-if="item.senderType == 0">
                            <img class="hbl_left" :src="webImg + tabList[tabIndex].icon" />
                            <div class="hbl_right">
                                <div class="blr_top" v-html="markedt(preprocessLaTeX(item.content))"></div>
                                <!-- <div class="blr_bottom">
                                        <div class="lrb_btn">
                                            <img src="../../assets/img/i23.png" />
                                            下载
                                        </div>
                                        <div class="lrb_btn">
                                            <img src="../../assets/img/i22.png" />
                                            复制
                                        </div>
                                    </div> -->
                            </div>
                        </div>
                        
                        <div class="chb_right" v-else>
                            <div class="hbr_text">
                                <img class="hbr_img" :src="webImg + itemA" v-for="(itemA,indexA) in item.imgArr" :key="indexA" v-if="item.path.length > 0"/>
                                <div v-if="item.content">{{ item.content }}</div>
                            </div>
                            
                            <img class="hbr_tx" :src="webImg + stuItem.avatar" />
                        </div>
                    </div>
                    <el-empty description="暂无数据" v-if="chatList.length == 0"></el-empty>
                </div>
            </div>
            <div class="b_right">
                <div class="br_tit">数据看板</div>
                <div class="br_box" id="twoChart" v-if="chartInfo && chartInfo.indicator.length > 0"></div>
                <el-empty description="暂无数据" v-else></el-empty>
                <div class="br_bottom">
                    <div class="brb_top">课堂分析结果</div>
                    <div class="brb_bottom" v-html="markedt(preprocessLaTeX(stuEvaluate || ''))" v-if="stuEvaluate"></div>
                    <el-empty description="暂无数据" v-else></el-empty>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag1">
            <div class="p_bg" @click.stop="flag1 = false"></div>
            <div class="addClass">
                <div class="ac_title">
                    <div>班级分析</div>
                    <img src="../../assets/img/i18.png" @click="flag1 = false" />
                </div>
                <div class="ac_content">
                    <div class="tj_top">
                        <div class="tjt_top">{{ ktInfo.courseName }}</div>
                        <div class="tjt_bottom">班级：{{ ktInfo.className }} <div></div> 学科：{{ ktInfo.subjectName }} <div>
                            </div>
                            上课人数：{{ stuList.length }}人 <div></div> 上课老师：{{ userInfo.nickName }}</div>
                    </div>
                    <div class="tj_bottom">
                        <div class="tjb_left">
                            <div class="jbl_top">
                                <div class="blt_left">班级智能体使用数据雷达图</div>
                                <!-- <div class="blt_right">数量：{{ tabList.length }}</div> -->
                            </div>
                            <div class="jbl_bottom" id="threeChart"
                                v-if="threeChartInfo && threeChartInfo.indicator.length > 0"></div>
                            <el-empty description="暂无数据" v-else></el-empty>
                        </div>
                        <div class="tjb_right">
                            <div class="jbr_top">智能体使用情况分析说明</div>
                            <div class="jbr_bottom" v-html="markedt(preprocessLaTeX(ktInfo.evaluate))" v-if="ktInfo.evaluate"></div>
                            <el-empty description="暂无数据" v-else></el-empty>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pop" v-if="flag3">
            <div class="p_bg" @click.stop="flag3 = false"></div>
            <div class="addClass" style="height:550px;">
                <div class="ac_title">
                    <div>请选择需要采集数据的智能体</div>
                    <img src="../../assets/img/i18.png" @click="flag3 = false" />
                </div>
                <div class="ac_content">
                    <div class="acc_select">
                        <div class="ccs_tit"><span>*</span>本堂课已使用的智能体：</div>
                        <div class="ccs_box">
                            <div class="csb_list">
                                <div class="sbl_tit">待选择</div>
                                <div class="sbl_list">
                                    <div class="bll_item" v-for="(item, index) in availableItems" :key="index"
                                        @click="btn_selectAdd(item, index)">
                                        <img class="lli_left"
                                            :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                        <div class="lli_right">
                                            <img class="lir_left" :src="webImg + item.icon" />
                                            <div class="lir_right">
                                                <div>{{ item.helperName }}</div>
                                                <div>{{ item.note }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="sbl_btn">
                                <div class="blb_btn1" @click="addItems">添加</div>
                                <div class="blb_btn2" @click="removeItems">移除</div>
                            </div>
                            <div class="csb_list">
                                <div class="sbl_tit">已选择（{{ selectedItems.length }}）</div>
                                <div class="sbl_list">
                                    <div class="bll_item" v-for="(item, index) in selectedItems" :key="index"
                                        @click="btn_selectRemove(item, index)">
                                        <img class="lli_left"
                                            :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                        <div class="lli_right">
                                            <img class="lir_left" :src="webImg + item.icon" />
                                            <div class="lir_right">
                                                <div>{{ item.helperName }}</div>
                                                <div>{{ item.note }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ccs_bottom">
                            <div class="csb_btn" @click="flag3 = false">取消</div>
                            <div class="csb_btn1" @click="submit">提交</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="finishClassPop" width="30%">
            <span>是否确定结束上课?结束后课堂将进行AI分析，重新上课请点击新建课堂</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="finishClassPop = false">取 消</el-button>
                <el-button type="primary" @click="btn_finish">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import MarkdownIt from 'markdown-it'
// import mk from 'markdown-it-katex';
import '@/assets/katex/dist/katex.min.css';
import markdownItKatex from '@iktakahiro/markdown-it-katex';

import {
    courseDetail,
    courseHelperList,
    courseInfo,
    courseStuList,
    courseStuMsgList,
    updateTechClassHelperStatus,
    classHelperDetail,
    finishTechClassCourse,
    startTechClassCourse,
    courseStatisticalAnalysis,
    techClassHelperStudent,
    queryEvaluateStatus,
    courseBindingHelper,
    courseOpenHelper
} from '@/apis/index'
const markdownRender = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    breaks: true
});
markdownRender.use(markdownItKatex);
// markdownRender.use(mk);
export default {
    data() {
        return {
            flag3: false,
            finishClassPop: false,
            flag1: false,
            flag: false,
            tab: 0,
            ktId: '',
            ktInfo: {},
            tabList: [],
            tabIndex: 0,
            helperId: '',
            stuList: [],
            stuId: '',
            chatList: [],
            zntStatus: null,
            stuItem: {},
            chartInfo: {},
            stuEvaluate: '',
            userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
            threeChartInfo: {},
            zntEve: '',
            timer: '',
            isOne: true,
            availableItems: [],//可添加的项目列表
            selectedItems: [],//已添加的项目列表
            selectedAvailable: [], //存储选中的项目用于存储当前选中的项目
            selectedSelected: [],//用于存储当前选中的项目
            helperEvaluateStatus: ''
        }
    },
    mounted() {
        if (this.$route.query.id) {
            this.ktId = this.$route.query.id
        }
        this.getCourseInfo()

    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        btn_openCt() {
            courseOpenHelper(this.helperId).then(res => {
                console.log(res, 'courseOpenHelper');
                this.getCourseInfo()
                this.getClassHelperDetail()
            })
        },
        submit() {
            courseBindingHelper({
                id: this.tabList[this.tabList.length - 1].id,
                techClassHelperIds: this.selectedItems.map(item => item.id).join(',')
            }).then(res => {
                console.log(res, 'courseBindingHelper');
                this.flag3 = false
                this.$message({
                    message: '提交成功！',
                    type: 'success'
                });
                // this.getCourseInfo()
            })
        },
        btn_selectRemove(item, index) {
            item.select = item.select == 0 ? 1 : 0
            this.$forceUpdate()
            if (item.select == 1) {
                this.selectedSelected.push(item)
            } else {
                this.selectedSelected.splice(index, 1)
            }
        },
        btn_selectAdd(item, index) {
            item.select = item.select == 0 ? 1 : 0
            this.$forceUpdate()
            if (item.select == 1) {
                this.selectedAvailable.push(item)
            } else {
                this.selectedAvailable.splice(index, 1)
            }
        },
        addItems() {
            this.selectedAvailable.forEach(e => { e.select = 0 })
            this.selectedItems.push(...this.selectedAvailable);
            this.availableItems = this.availableItems.filter(item => !this.selectedAvailable.includes(item));
            this.selectedAvailable = [];
        },
        removeItems() {
            this.selectedSelected.forEach(e => { e.select = 0 })
            this.availableItems.push(...this.selectedSelected);
            this.selectedItems = this.selectedItems.filter(item => !this.selectedSelected.includes(item));
            this.selectedSelected = [];
        },
        getQueryEvaluateStatus() {
            queryEvaluateStatus(this.helperId).then(res => {
                console.log(res, 'getQueryEvaluateStatus');
                this.helperEvaluateStatus = res.data.helperEvaluateStatus
                this.stuList.forEach((item, index) => {
                    item.evaluateStatus = res.data.techClassHelperStudentList[index].evaluateStatus
                    item.score = res.data.techClassHelperStudentList[index].score
                })
            })
        },
        btn_open(type) {
            if (process.env.NODE_ENV === 'development') { //development   production
                //开发环境
                window.open(`http://localhost:8081/#/simultaneousInterpretation?type=${type}`, '_blank')
            } else {
                window.open(`https://laoshiai.cn/#/simultaneousInterpretation?type=${type}`, '_blank')
            }
        },
        markedt(markdown) {
            // markdown = markdown.replace(/\$(.*?)\$/g, (match, p1) => {
            //     // 在匹配的内容中替换乘号和 \frac
            //     const replaced = p1
            //         .replace(/×/g, '\\times') // 替换乘号
            //         // .replace(/\frac/g, '\\\\frac'); // 替换 \frac
            //     return `$${replaced}$`; // 返回替换后的内容
            // });
            if (markdown) {
                return markdownRender.render(markdown);
            }
            return '';
        },
        gettechClassHelperStudent() {
            techClassHelperStudent(this.stuId, this.helperId).then(res => {
                console.log(res, 'res');
                this.stuEvaluate = res.data.evaluate
            })
        },
        async btn_analysis() {
            await this.getCourseInfo()
            if (this.ktInfo.evaluateStatus == 0) {
                this.$message({
                    message: '下课后才可以查看分析结果！',
                    type: 'warning'
                });
                return
            }
            if (this.ktInfo.evaluateStatus == 1) {
                this.$message({
                    message: 'AI分析中，数据量较大，预计用时2分钟，请耐心等待！',
                    type: 'warning'
                });
                return
            }
            this.flag1 = true
            var list = JSON.parse(JSON.stringify(this.tabList))
            list.forEach((item, index) => {
                item.ifChoose = true
            })
            courseStatisticalAnalysis([], this.ktId).then(res => {
                console.log(res, 'threeChartInfo');
                this.threeChartInfo = res.data[0]
                setTimeout(() => {
                    this.initThreeChart()
                }, 500);
            })
        },
        getcourseStatisticalAnalysis() {
            this.tabList.forEach((item, index) => {
                if (index == this.tabIndex) {
                    item.ifChoose = true
                } else {
                    item.ifChoose = false
                }
            })
            courseStatisticalAnalysis(this.tabList, this.ktId, this.stuId).then(res => {
                this.chartInfo = res.data[0]
                console.log(this.chartInfo, 'courseStatisticalAnalysis');
                setTimeout(() => {
                    if (this.stuId) {
                        this.initTwoChart()
                    } else {
                        this.initChart()
                    }
                }, 500);
                // if (this.chartInfo.indicator.length > 0) {

                // }else{
                //     this.chartInfo = {}
                // }
            })
        },
        btn_finish() {
            finishTechClassCourse(this.ktId).then(res => {
                console.log(res, 'res');
                this.finishClassPop = false
                this.getCourseInfo()
            })
        },
        btn_start() {
            startTechClassCourse(this.ktId).then(res => {
                console.log(res, 'res');
                this.getCourseInfo()
            })
        },
        getClassHelperDetail() {
            classHelperDetail(this.helperId).then(res => {
                console.log(res, 'res');
                this.zntStatus = res.data.status
                this.zntEve = res.data.evaluate
            })
        },
        startAndEnd(status) {
            this.throttle(() => {
                this.getCourseHelperList()
                if (this.tabList[this.tabIndex].evaluateStatus == 1) {
                    this.$message.warning('AI正在分析中，预计用时2分钟，请耐心等待！')
                    return
                }

                updateTechClassHelperStatus(status, this.helperId).then(resA => {
                    this.getClassHelperDetail()
                    this.getQueryEvaluateStatus()
                    console.log(resA, 'res');
                    this.getCourseInfo()
                })
            }, 3000)
        },
        getCourseStuMsgList() {
            this.chatList = []
            courseStuMsgList(this.stuId, this.helperId).then(res => {
                console.log(res)
                this.flag = true
                if (res.data) {
                    res.data.forEach(e=>{
                        if(e.path){
                            e.imgArr = e.path.split(',')
                        }
                    })
                    this.chatList = res.data
                    console.log(this.chatList,'chatList');
                    
                }
            })
        },
        btn_stu(item, index) {
            this.stuId = item.studentId
            this.stuItem = item
            this.getCourseStuMsgList()
            this.gettechClassHelperStudent()
            setTimeout(() => {
                this.getcourseStatisticalAnalysis()
            }, 500);
        },
        getCourseStuList() {
            courseStuList(this.helperId).then(res => {
                console.log(res)
                this.stuList = res.data
                // this.$nextTick(() => {
                //     this.handleScrollBottom()
                // })
            })
        },
        btn_tab(index) {
            this.tabIndex = index
            this.helperId = this.tabList[index].id
            this.getCourseStuList()
            this.getClassHelperDetail()
            this.getcourseStatisticalAnalysis()
            setTimeout(() => {
                this.getQueryEvaluateStatus()
            }, 500);
        },
        getCourseInfo() {
            courseInfo(this.ktId).then(res => {
                console.log(res)
                this.ktInfo = res.data
                this.getCourseHelperList()
            })
        },
        getCourseHelperList() {
            courseHelperList(this.ktId).then(res => {
                console.log(res)
                this.tabList = res.data
                this.availableItems = JSON.parse(JSON.stringify(res.data))
                this.availableItems = this.availableItems.filter(item => item.type != 4);
                this.availableItems.forEach(e => { e.select = 0 })
                this.$forceUpdate()
                this.helperId = this.tabList[this.tabIndex].id
                this.getCourseStuList()
                this.getQueryEvaluateStatus()
                this.getClassHelperDetail()

                if (this.isOne) {
                    this.isOne = false
                    this.timer = setInterval(() => {
                        this.getQueryEvaluateStatus()
                        this.getClassHelperDetail()

                    }, 5000);
                }
                this.getcourseStatisticalAnalysis()
            })
        },
        getCourseDetail() {
            courseDetail(this.ktId).then(res => {
                console.log(res)
                this.zntStatus = res.data.status
            })
        },
        initThreeChart() {
            var option = {
                // color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {},
                legend: {
                    data: this.threeChartInfo.legend,
                    left: 'center',
                    top: '25',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                    show: false
                },
                radar: {
                    radius: '50%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    indicator: this.threeChartInfo.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.threeChartInfo.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            const myChart = this.$echarts.init(document.getElementById('threeChart'))
            myChart.setOption(option)
        },
        initTwoChart() {
            var option = {
                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {},
                legend: {
                    data: this.chartInfo.legend,
                    left: 'center',
                    top: '0%',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                },
                radar: {
                    radius: '50%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    indicator: this.chartInfo.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.chartInfo.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            const myChart = this.$echarts.init(document.getElementById('twoChart'))
            myChart.setOption(option)
        },
        initChart() {
            var option = {
                color: ['#67F9D8', '#FFE434', '#56A3F1', '#FF917C'],
                tooltip: {},
                legend: {
                    data: this.chartInfo.legend,
                    left: 'center',
                    top: '0%',
                    icon: 'roundRect',
                    itemWidth: 12,
                    itemHeight: 12,
                },
                radar: {
                    radius: '50%',
                    center: ["center", "center"],
                    // shape: 'circle',
                    indicator: this.chartInfo.indicator
                },
                series: [
                    {
                        type: 'radar',
                        data: this.chartInfo.seriesData,
                        areaStyle: {}
                    }
                ]
            };
            const myChart = this.$echarts.init(document.getElementById('oneChart'))
            myChart.setOption(option)
            // window.addEventListener('resize', () => {
            //     setTimeout(() => {
            //         myChart.resize()
            //     }, 500)
            // })
        },
        // 滚动到底部
        handleScrollBottom() {
            this.$nextTick(() => {
                let scrollElem = this.$refs.scrollDiv;
                scrollElem.scrollTo({ top: scrollElem.scrollHeight, behavior: 'smooth' });
            });
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
img{
    width: 100%;
}
    code {
        /*元素内的空白保留，并允许换行*/
        white-space: pre-wrap !important;
        /*是否允许在单词内断句*/
        word-wrap: break-word !important;
        font-family: PingFang;
    }

    .katex-html {
        // display: none !important;
    }

    annotation {
        display: none !important;
    }

    table {
        border-collapse: collapse;
        /* 确保表格的边框线会合并为单一的线条 */
        border: 1px solid black;
        /* 设置表格的边框 */
    }

    td,
    th {
        border: 1px solid black;
        /* 设置单元格的边框 */
    }

    h1 {
        font-size: 16px;
        font-weight: bold;
    }

    h2 {
        font-size: 16px;
        font-weight: bold;
    }

    h3 {
        font-size: 16px;
        font-weight: bold;
    }

    p {
        font-size: 16px;
    }

    li {
        font-size: 16px;
    }
}
.addClass {
    width: 972px;
    height: 650px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    top: 370px;
    /* 距离顶部 50% */
    left: 50%;
    /* 距离左侧 50% */
    transform: translate(-50%, -50%);
    z-index: 4;

    .ac_title {
        width: 100%;
        height: 42px;
        border-radius: 10px 10px 0 0;
        background: #F4F6FB;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;

        div {
            font-weight: bold;
            font-size: 18px;
            color: #000000;
        }

        img {
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }

    .ac_content {
        width: 100%;

        .acc_input {
            width: 100%;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding: 0 210px 0 30px;
            margin-top: 15px;

            .cci_left {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                width: 130px;
                text-align: right;

                span {
                    font-weight: bold;
                    font-size: 14px;
                    color: #FF0000;
                    margin-right: 4px;
                }
            }

            input {
                flex: 1;
                margin-left: 10px;
                height: 32px;
                background: #FFFFFF;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #CED4DB;
                box-sizing: border-box;
                padding: 0 8px;
            }
        }

        .acc_line {
            width: 100%;
            height: 1px;
            background-color: #ECECEC;
            margin: 20px 0;
        }

        .acc_select {
            width: 100%;

            .ccs_tit {
                width: 100%;
                box-sizing: border-box;
                padding: 0 210px 0 75px;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                margin-bottom: 15px;

                span {
                    font-weight: bold;
                    font-size: 14px;
                    color: #FF0000;
                    margin-right: 4px;
                }
            }

            .ccs_box {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;

                .csb_list {
                    width: 280px;
                    height: 350px;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #F0F0F0;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .sbl_tit {
                        width: 100%;
                        height: 35px;
                        border-bottom: 1px solid#ECECEC;
                        font-weight: bold;
                        font-size: 16px;
                        color: #333333;
                        line-height: 35px;
                        box-sizing: border-box;
                        padding: 0 20px;
                    }

                    .sbl_list::-webkit-scrollbar {
                        display: none;
                    }

                    .sbl_list {
                        width: 100%;
                        height: 0;
                        flex: 1;
                        overflow-y: scroll;

                        .bll_item {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding: 0 20px;
                            margin-top: 15px;
                            cursor: pointer;

                            .lli_left {
                                width: 14px;
                                height: 14px;
                            }

                            .lli_right {
                                flex: 1;
                                display: flex;
                                align-items: center;
                                margin-left: 15px;

                                .lir_left {
                                    width: 36px;
                                    height: 36px;
                                }

                                .lir_right {
                                    flex: 1;
                                    margin-left: 8px;

                                    div:nth-child(1) {
                                        font-weight: 500;
                                        font-size: 16px;
                                        color: #000000;
                                    }

                                    div:nth-child(2) {
                                        font-weight: 500;
                                        font-size: 12px;
                                        color: #999999;
                                        margin-top: 8px;
                                    }
                                }
                            }
                        }
                    }
                }

                .sbl_btn {
                    margin: 0 30px;

                    .blb_btn1 {
                        width: 64px;
                        height: 36px;
                        background: #399AFF;
                        border-radius: 8px 8px 8px 8px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 36px;
                        cursor: pointer;

                    }

                    .blb_btn2 {
                        width: 64px;
                        height: 36px;
                        background: #F75A5A;
                        border-radius: 8px 8px 8px 8px;
                        font-weight: bold;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: center;
                        line-height: 36px;
                        margin-top: 30px;
                        cursor: pointer;

                    }
                }
            }

            .ccs_bottom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;

                .csb_btn {
                    width: 164px;
                    height: 40px;
                    background: #FFFFFF;
                    border-radius: 8px 8px 8px 8px;
                    border: 1px solid #399AFF;
                    font-weight: bold;
                    font-size: 16px;
                    color: #399AFF;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 7px;
                    cursor: pointer;
                }

                .csb_btn1 {
                    width: 164px;
                    height: 40px;
                    background: #399AFF;
                    border-radius: 8px 8px 8px 8px;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    line-height: 40px;
                    margin: 0 7px;
                    cursor: pointer;
                }
            }
        }
    }
}

.line1_ {
    white-space: pre-wrap;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.body {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    // z-index: 1;

    .popup {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 2;
    }

    .addClass {
        width: 972px;
        height: 650px;
        background: #FFFFFF;
        border-radius: 10px;
        position: absolute;
        top: 370px;
        /* 距离顶部 50% */
        left: 50%;
        /* 距离左侧 50% */
        transform: translate(-50%, -50%);
        z-index: 3;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ac_title {
            width: 100%;
            height: 42px;
            background: #F4F6FB;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 20px;
            border-radius: 10px 10px 0 0;


            div {
                font-weight: bold;
                font-size: 18px;
                color: #000000;
            }

            img {
                width: 16px;
                height: 16px;
                cursor: pointer;
            }
        }

        .ac_content {
            width: 100%;
            height: 0;
            flex: 1;
            box-sizing: border-box;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .tj_top {
                width: 100%;
                height: 120px;
                box-sizing: border-box;
                padding: 20px;
                background: #2992FF;
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;

                .tjt_top {
                    width: 100%;
                    text-align: left;
                    font-weight: bold;
                    font-size: 28px;
                    color: #FFFFFF;
                }

                .tjt_bottom {
                    width: 100%;
                    text-align: left;
                    font-weight: 500;
                    font-size: 18px;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;

                    div {
                        width: 2px;
                        height: 18px;
                        background-color: #fff;
                        margin: 0 15px;
                    }
                }
            }

            .tj_bottom {
                flex: 1;
                height: 0;
                width: 100%;
                display: flex;
                align-items: flex-start;
                margin-top: 30px;

                .tjb_left {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    border-right: 1px solid#ECECEC;

                    .jbl_top {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        box-sizing: border-box;
                        padding-right: 30px;

                        .blt_left {
                            font-weight: bold;
                            font-size: 20px;
                            color: #000000;
                        }

                        .blt_right {
                            font-weight: bold;
                            font-size: 16px;
                            color: #2992FF;
                        }
                    }

                    .jbl_bottom {
                        width: 100%;
                        height: 0;
                        flex: 1;
                    }
                }

                .tjb_right {
                    width: 50%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    .jbr_top {
                        padding-left: 30px;
                        font-weight: bold;
                        font-size: 20px;
                        color: #000000;
                    }

                    .jbr_bottom::-webkit-scrollbar {
                        display: none;
                    }

                    .jbr_bottom {
                        width: 100%;
                        height: 350px;
                        box-sizing: border-box;
                        padding-right: 30px;
                        overflow-y: scroll;
                        padding-left: 30px;
                        font-weight: 500;
                        font-size: 14px;
                        color: #666666;
                        line-height: 28px;
                        margin-top: 30px;
                    }
                }
            }
        }
    }

    .pop {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
        }

        .b_right::-webkit-scrollbar {
            display: none;
        }

        .b_right {
            z-index: 4;
            background-color: #fff;
            width: 380px;
            height: 700px;
            border: 1px solid #EDEDED;
            border-radius: 0px 30px 30px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow-y: scroll;
            box-sizing: border-box;

            .br_tit {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
                font-weight: bold;
                font-size: 20px;
                color: #000000;

            }

            .br_box {
                // flex: 1;
                height: 380px;
                width: 100%;
            }

            .br_bottom {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;

                .brb_top {
                    font-weight: bold;
                    font-size: 20px;
                    color: #000000;
                }

                .brb_bottom {
                    width: 100%;
                    // height: 70px;
                    // overflow-y: scroll;
                    font-weight: 500;
                    font-size: 14px;
                    color: #666666;
                    line-height: 28px;
                    margin-top: 15px;
                }
            }
        }
    }

    .chat {
        // flex: 1;
        // height: 0;
        // position: absolute;
        // top: 370px;
        /* 距离顶部 50% */
        // left: 50%;
        /* 距离左侧 50% */
        // transform: translate(-50%, -50%);
        z-index: 4;
        background-color: #fff;
        width: 1000px;
        height: 700px;
        border-radius: 30px 0px 0px 30px;
        border: 1px solid #EDEDED;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .ch_top {
            width: 100%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid#ECECEC;
            position: relative;

            .close {
                position: absolute;
                right: 10px;
                top: 20px;
                width: 16px;
                height: 16px;
                cursor: pointer;
            }

            .cht_left {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
                line-height: 60px;
            }

            .cht_right {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 16px;
                color: #333333;
                line-height: 60px;
                margin-right: 50px;

                .htr_stu {
                    font-weight: 500;
                    font-size: 16px;
                    color: #2992FF;
                    margin-right: 10px;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 5px;
                    }
                }

                .htr_znt {
                    font-weight: 500;
                    font-size: 16px;
                    color: #2992FF;
                    margin-left: 10px;
                    margin-right: 10px;

                    img {
                        width: 36px;
                        height: 36px;
                        margin-right: 5px;
                    }
                }
            }
        }

        .ch_bottom::-webkit-scrollbar {
            display: none;
        }

        .ch_bottom {
            width: 100%;
            height: 0;
            flex: 1;
            overflow-y: scroll;
            margin-bottom: 15px;

            .chb_item {
                width: 100%;
                margin-top: 20px;

                .chb_left {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;

                    .hbl_left {
                        width: 44px;
                        height: 44px;
                    }

                    .hbl_right {
                        // flex: 1;
                        margin-left: 20px;
                        max-width: 500px;
                        background: #FAFAFA;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;

                        .blr_top {
                            font-weight: 500;
                            font-size: 16px;
                            color: #333333;
                            line-height: 32px;
                        }

                        .blr_bottom {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            border-top: 1px solid#ececec;
                            margin-top: 10px;
                            padding-top: 10px;

                            .lrb_btn {
                                font-weight: 500;
                                font-size: 14px;
                                color: #333333;
                                margin-right: 30px;
                                display: flex;
                                align-items: center;
                                cursor: pointer;

                                img {
                                    width: 14px;
                                    height: 14px;
                                    margin-right: 5px;
                                }
                            }
                        }
                    }
                }

                .chb_right {
                    display: flex;
                    align-items: flex-start;
                    justify-content: flex-end;

                    .hbr_text {
                        max-width: 500px;
                        background: #2992FF;
                        border-radius: 10px 10px 10px 10px;
                        font-weight: 500;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 32px;
                        box-sizing: border-box;
                        padding: 10px;
                    }
                    .hbr_img{
                        max-width: 500px;
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;
                        padding: 10px;
                        border-radius: 8px;
                    }
                    .hbr_tx {
                        width: 44px;
                        height: 44px;
                        margin-left: 20px;

                    }
                }
            }
        }
    }

    .bg {
        width: 100%;
        height: 228px;
        background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
        position: absolute;
        top: 0;
        left: 0;
        // z-index: -1;
    }

    .content {
        width: 1200px;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;

        .back {
            width: 100%;
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 14px;
            color: #000000;
            margin-bottom: 10px;
            margin-top: 10px;
            cursor: pointer;

            img {
                width: 14px;
                height: 14px;

            }
        }

        .top {
            width: 100%;
            height: 100px;
            background: #2992FF;
            border-radius: 16px 16px 16px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 30px;

            .top_left {
                display: flex;
                align-items: center;

                .t_left {
                    width: 70px;
                    height: 70px;
                    border-radius: 10px 10px 10px 10px;
                }

                .t_right {
                    flex: 1;
                    margin-left: 30px;

                    .tr_top {
                        display: flex;
                        align-items: center;

                        .trt_left {
                            font-weight: bold;
                            font-size: 24px;
                            color: #FFFFFF;
                            margin-right: 14px;
                        }

                        .trt_right {
                            width: 115px;
                            height: 28px;
                            background: #FFFFFF;
                            border-radius: 8px 8px 8px 8px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 800;
                            font-size: 14px;
                            color: #2992FF;
                            cursor: pointer;

                            img:nth-child(1) {
                                width: 16px;
                                height: 16px;
                                margin-right: 2px;
                            }

                            img:nth-child(2) {
                                width: 5px;
                                height: 8px;
                                margin-left: 10px;
                            }
                        }
                    }

                    .tr_bottom {
                        font-weight: 500;
                        font-size: 18px;
                        color: #FFFFFF;
                        margin-top: 18px;
                        display: flex;
                        align-items: center;

                        div {
                            height: 18px;
                            width: 2px;
                            background-color: #fff;
                            margin: 0 15px;
                        }
                    }
                }
            }
        }

        .top_right {
            display: flex;
            align-items: center;

            .tr_btn2 {
                width: fit-content;
                height: 36px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #2992FF;
                margin-right: 20px;
                cursor: pointer;
                box-sizing: border-box;
                padding: 0 10px;

                img {
                    width: 16px;
                    height: 16px;
                    margin-right: 10px;
                }
            }

            .tr_btn1 {
                width: 128px;
                height: 36px;
                background: #FF4B4B;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #FFFFFF;
                cursor: pointer;

                img {
                    width: 15px;
                    height: 16px;
                    margin-right: 10px;
                }
            }

            .tr_btn {
                width: 128px;
                height: 36px;
                border: 1px solid #2992FF;
                background: #F2F9FF;
                border-radius: 8px 8px 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 800;
                font-size: 16px;
                color: #2992FF;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 16px;
                    margin-right: 10px;
                }
            }
        }
    }

}

.center {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .c_left::-webkit-scrollbar {
        // display: none;
        height: 10px;
        // background-color: #1096F1;
    }

    .c_left::-webkit-scrollbar-thumb {
        background: #c2c2c2;
        /* 滑块颜色 */
        border-radius: 10px;
        /* 滑块圆角 */
    }

    .c_left {
        flex: 1;
        margin-right: 30px;
        overflow-x: scroll;
        padding: 5px;
        white-space: nowrap;

        .cll1 {
            // filter: blur(0) !important;

        }

        .cll {
            color: #1096F1 !important;
        }

        .tooltip {
            position: relative;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 8px;
            padding: 10px 15px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            font-size: 14px;
            color: #333;
            margin-bottom: 10px;
            /* 为引导线留出空间 */
        }

        .cl_label::after {
            content: '';
            position: absolute;
            top: 100%;
            /* 在气泡下方 */
            left: 50%;
            /* 水平居中 */
            margin-left: -5px;
            /* 调整位置 */
            border-width: 5px;
            /* 引导线的大小 */
            border-style: solid;
            border-color: #fff transparent transparent transparent;
            /* 下边框为白色，其他为透明 */
        }

        .cl_label::before {
            content: '';
            position: absolute;
            top: 100%;
            /* 在气泡下方 */
            left: 50%;
            /* 水平居中 */
            margin-left: -6px;
            /* 调整位置 */
            border-width: 6px;
            /* 引导线的大小 */
            border-style: solid;
            border-color: #ccc transparent transparent transparent;
            /* 下边框为灰色，其他为透明 */
            z-index: -1;
            /* 使背景引导线在气泡后面 */
        }

        .cl_label {
            width: 140px;
            height: 80px;
            background: #FFFFFF;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px 10px 10px 10px;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-right: 30px;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0 10px;
            // opacity: .5;
            // filter: blur(5px);
            // background: rgba(255, 255, 255, 0.5); /* 半透明背景 */
            // backdrop-filter: blur(10px); /* 背景虚化 */

            .switch {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 15px;
                height: 15px;
                cursor: pointer;
                // background: #000;
            }

            img {
                width: 36px;
                height: 36px;
                border-radius: 6px;
            }

            .cll_tit {
                width: 100%;
                text-align: center;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                margin-top: 8px;
            }

            .cll_line {
                width: 60px;
                height: 4px;
                background: #1096F1;
                border-radius: 2px 2px 2px 2px;
                position: absolute;
                bottom: 0;
            }
        }
    }

    .c_right1 {
        width: 128px;
        height: 36px;
        background: #FF4B4B;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;

        img {
            width: 15px;
            height: 16px;
            margin-right: 10px;
        }
    }

    .c_right {
        width: 128px;
        height: 36px;
        background: #399AFF;
        border-radius: 8px 8px 8px 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 800;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;

        img {
            width: 14px;
            height: 16px;
            margin-right: 10px;
        }
    }
}

.bottom {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;

    .b_left::-webkit-scrollbar {
        display: none;
    }

    .b_left {
        width: 800px;
        height: 100%;
        overflow-y: scroll;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        border-radius: 30px 30px 30px 30px;
        border: 1px solid #EDEDED;
        box-sizing: border-box;
        padding: 20px 0;

        .bl_item {
            width: 130px;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            margin-bottom: 20px;
            cursor: pointer;
            position: relative;
            .b1{
                border: 3px solid #5DDB85;
            }
            .border{
                width: 26px;
                height: 26px;
                position: absolute;
                bottom: 15px;
                right: 20px;
                border: 0;
            }
            .blil {
                color: #ff2929 !important;
                border: 1px solid #ff2929 !important;
            }

            .bli_label {
                width: fit-content;
                background: #FFFFFF;
                border-radius: 2px;
                border: 1px solid #27C189;
                font-weight: 500;
                font-size: 12px;
                color: #27C189;
                position: absolute;
                bottom: 25px;
                box-sizing: border-box;
                padding: 2px 5px;
            }

            img {
                width: 60px;
                height: 60px;
                border-radius: 6px;
                margin-bottom: 20px;
                box-sizing: border-box;
            }
        }
    }

    .b_right::-webkit-scrollbar {
        display: none;
    }

    .b_right {
        width: 380px;
        height: 100%;
        border: 1px solid #EDEDED;
        border-radius: 30px 30px 30px 30px;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        overflow-y: scroll;

        .br_tit {
            width: 100%;
            box-sizing: border-box;
            padding: 20px;
            font-weight: bold;
            font-size: 20px;
            color: #000000;
            display: flex;
            align-items: center;

            .brt_left {}

            .brt_right {
                flex: 1;

                // display: flex;
                // align-items: center;
                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 2px;
                }

                div {
                    flex: 1;
                    width: 100%;
                }
            }
        }

        .br_box {
            // flex: 1;
            height: 380px;
            width: 100%;
        }

        .br_bottom {
            width: 100%;
            box-sizing: border-box;
            padding: 20px;

            .brb_top {
                font-weight: bold;
                font-size: 20px;
                color: #000000;
            }

            .brb_bottom {
                width: 100%;
                // height: 70px;
                // overflow-y: scroll;
                font-weight: 500;
                font-size: 14px;
                color: #666666;
                line-height: 28px;
                margin-top: 15px;
            }
        }
    }
}

// }
// }</style>